import PageTitle from "../Common/PageTitle"
import ToolBar from "../Common/Toolbar"
import { FC, Fragment, useEffect, useState } from "react"
import columns from "./columns"
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import MenuListPop from "../Common/menu"
import { DeleteOutlineOutlined, EditOutlined } from "@mui/icons-material"
import { Apis, numberWithCommas } from "../../helpers"
import { PropertyProps } from "../../types/properties"
import NoData from "../Common/NoData"
import { useNavigate } from "react-router-dom"
import { Connect, mapStateToProps } from "../../Redux"
import moment from 'moment'
import DeleteModal from '../Common/deletePrompt'
import { PaymentProps } from "../../types/payment"
import { TABLE_HEIGHT } from "../../configs"
import { TenantProps } from "../../types/tenants"


interface StateProps {
    data: PaymentProps[]
    loading: boolean
    showDeleteModal: null | PaymentProps
    refreshing: boolean
}
interface Props {
    tablesColumnsFilters?: {
        payments: string[]
    }
    selectedProperty?: PropertyProps
    tenant?: TenantProps
}
const Payments: FC<Props> = ({
    selectedProperty,
    tablesColumnsFilters,
    tenant
}) => {
    const [state, setState] = useState<StateProps>({
        data: [],
        showDeleteModal: null,
        loading: true,
        refreshing: false
    })
    const navigate = useNavigate()

    const menuList = [
        { label: 'Edit', icon: <EditOutlined /> },
        { label: 'Delete', icon: <DeleteOutlineOutlined /> }
    ]
    const { data, loading, showDeleteModal, refreshing } = state
    const DisplayColums = columns.filter(col => (tenant ? ['payment', 'action'] : tablesColumnsFilters?.payments)?.includes(col.name))
    const getPropertyPayments = ({
        refreshing
    }: any) => {
        if (refreshing)
            setState({ ...state, refreshing: true })
        Apis({
            module: 'Payments',
            action: 'getPropertyPayments',
            propertId: selectedProperty?._id,
            tenantId: tenant?._id,
            page:0,
            pageSize:50
        }).then((data: any) => {
            setState({ ...state, data, loading: false })
        }).catch(() => {
            setState({
                ...state,
                loading: false
            })
        })
    }
    useEffect(() => {
        getPropertyPayments({})
        // eslint-disable-next-line 
    }, [])
    return (
        <Box sx={{ height: '100%', pr: 5 }}>
            {!tenant ?
                <PageTitle title={"Payments"} /> :
                <Fragment />
            }
            {!loading && data.length ?
                <ToolBar
                    columnsFilter={'payments'}
                    columns={tenant ? undefined : columns}
                    noAddButton={Boolean(tenant)}
                    noSearch={Boolean(tenant)}
                    addTitle={'Create Payment'}
                    addPage={'/new_payment'}
                    refreshing={refreshing}
                    onRefresh={() => getPropertyPayments({ refreshing: true })}
                />
                : null}
            {
                !data?.length || loading ?
                    <NoData
                        createMessage={tenant?undefined:`Create Payment`}
                        onCreate={tenant?undefined:() => navigate('/new_payment')}
                        loading={loading}
                    /> :
                    <Paper sx={{ width: '100%' }}>
                        <TableContainer sx={{ maxHeight: tenant ? '70vh' : TABLE_HEIGHT }}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {
                                            DisplayColums.map(({ label }) => (
                                                <TableCell sx={{ fontWeight: 'bold' }} key={label} /*align={column.align}*/>
                                                    {label}
                                                </TableCell>
                                            ))
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        data.map((datam, i) => {
                                            return (
                                                <TableRow hover role="checkbox" tabIndex={-1} key={datam.title}>
                                                    {
                                                        DisplayColums.map(({ label, name, field, isDate, isNumber }, x) => {
                                                            let value = field && (datam as any)[name] ? (datam as any)[name][field] : (datam as any)[name] || 'None'
                                                            value = isDate ? moment(value).format('DD/MM/YYYY') : isNumber ? numberWithCommas(value) : value
                                                            return (
                                                                <TableCell key={label + '' + datam._id} /*align={column.align}*/>
                                                                    {
                                                                        name === 'action' ?
                                                                            <MenuListPop menuList={menuList} onSelect={option => {
                                                                                if (option === 'Edit')
                                                                                    navigate('/new_maintenance', { state: { record: datam } })
                                                                                else if (option === 'Delete')
                                                                                    setState({
                                                                                        ...state,
                                                                                        showDeleteModal: datam
                                                                                    })
                                                                            }} /> :
                                                                            value
                                                                    }
                                                                </TableCell>
                                                            )
                                                        })
                                                    }
                                                </TableRow>
                                            )
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
            }

            {
                showDeleteModal ?
                    <DeleteModal
                        item={showDeleteModal}
                        close={() => setState({ ...state, showDeleteModal: null })}
                        onDelete={() => {
                            const itemIndex = data?.findIndex(q => q._id === showDeleteModal?._id) as number
                            const Items = [...data as PaymentProps[]]
                            Items?.splice(itemIndex, 1)
                            setState({
                                ...state,
                                showDeleteModal: null,
                                data: Items
                            })

                        }}
                        deleteField={'_id'}
                        page='Maintenance'
                        module={'Maintenances'}
                        itemName={showDeleteModal.title}
                        maintenanceId={showDeleteModal._id}
                    /> :
                    <Fragment />

            }
        </Box>
    )
}

export default Connect(mapStateToProps)(Payments)